import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ErrorReportService } from '../../../tvf/errors-manager/services/errors.service';
import { ToastrService } from 'ngx-toastr';

class DirtyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, _form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid && control.dirty);
  }
}
interface ErrorModel {
  title?: string;
  error?: {
    errorText?: string;
    responsibleArea?: string;
    troubleshooting?: string;
    errorId?: string;
    errorType?: string;
  };
}

@Component({
  selector: 'app-modal-create-error',
  templateUrl: './modal-create-error.component.html',
  styleUrls: ['./modal-create-error.component.sass'],
})
export class ModalCreateErrorComponent implements OnInit {
  form: FormGroup;
  isEditMode = false;
  matcher = new DirtyErrorStateMatcher();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ErrorModel | null,
    private dialogRef: MatDialogRef<ModalCreateErrorComponent>,
    private fb: FormBuilder,
    private errorReportService: ErrorReportService,
    private toastr: ToastrService,
  ) {
    this.form = this.fb.group({
      message: ['', [Validators.required, Validators.maxLength(500)]],
      area: ['', [Validators.required, Validators.maxLength(150)]],
      troubleshooting: ['', [Validators.required, Validators.maxLength(500)]],
      errorType: ['', [Validators.required, Validators.maxLength(150)]],
    });
  }
  ngOnInit(): void {
    if (this.data?.error) {
      this.isEditMode = true;

      this.form.patchValue({
        message: this.data.error.errorText ?? '',
        area: this.data.error.responsibleArea ?? '',
        troubleshooting: this.data.error.troubleshooting ?? '',
        errorType: this.data.error.errorType ?? '',
      });
    }
  }
  update(): void {
    if (this.form.invalid) return;

    const payload = {
      errorText: this.form.value.message,
      responsibleArea: this.form.value.area,
      troubleshooting: this.form.value.troubleshooting,
      errorType: this.form.value.errorType,
    };

    this.errorReportService
      .updateError({
        id: this.data.error?.errorId,
        ...payload,
      })
      .subscribe({
        next: () => {
          this.dialogRef.close(true);
          this.toastr.success('Atualização realizada com sucesso.');
   
        },
        error: () => {
          this.toastr.error('Erro ao atualizar informações, tente novamente mais tarde.');
        },
      });
  }
  onCancel(): void {
    this.dialogRef.close();
  }

  create(): void {
    const payload = {
      errorText: this.form.value.message,
      responsibleArea: this.form.value.area,
      troubleshooting: this.form.value.troubleshooting,
      errorType: this.form.value.errorType,
    };

    this.errorReportService.createError(payload).subscribe({
      next: () => {
        this.toastr.success('Erro criado com sucesso.');
        this.dialogRef.close(true);
      },
      error: () => {
        this.toastr.error('Ocorreu um erro ao criar o erro, tente novamente mais tarde.');
      },
    });
  }
}
